<script>
  import { _ } from "svelte-i18n";
  export let user;

  let clubSuggestions = [];
  let selectedClub;

  const clubs = [
    { name: "Asker Kunstløpklubb", abbr: "AKK" },
    { name: "Austrått Kunstløpklubb", abbr: "AUK" },
    { name: "Bergen Kunstløpklubb", abbr: "BKK" },
    { name: "Bærum Skøyteklubb", abbr: "BSK" },
    { name: "Fana IL", abbr: "FIL" },
    { name: "Follo Kunstløpklubb", abbr: "FOL" },
    { name: "Fredrikstad Kunstløpklubb", abbr: "FKK" },
    { name: "Gjøvik Kunstløpklubb", abbr: "GKK" },
    { name: "Hamar IL", abbr: "HIL" },
    { name: "Ishavsbyen kunstløpklubb", abbr: "IKK" },
    { name: "Jar Idrettslag", abbr: "JIK" },
    { name: "Kongsvinger Kunstløpsklubb", abbr: "KKL" },
    { name: "Kristiansand Kunstløpklubb", abbr: "KK" },
    { name: "Lillehammer Kunstløpklubb", abbr: "LKK" },
    { name: "Loddefjord IL", abbr: "LIL" },
    { name: "Moss Kunstløpklubb", abbr: "MKK" },
    { name: "Oslo Idrettslag", abbr: "OI" },
    { name: "Oslo Skøiteklub", abbr: "OSK" },
    { name: "Romerike Kunstløpklubb", abbr: "RKK" },
    { name: "Sarpsborg Skøyteklubb", abbr: "SSK" },
    { name: "Stavanger Kunstløpklubb", abbr: "SKK" },
    { name: "Storhamar Kunstløp", abbr: "SIL" },
    { name: "Trondhjems Skøiteklubb", abbr: "TSK" },
    { name: "Trondhjem Skating Lag", abbr: "TSL" },
    { name: "Tønsbergs Turnforening", abbr: "TT" },
    { name: "Ullensaker Issportklubb", abbr: "UIK" },
  ];
</script>

<label class="input input--search" for="Klubb"
  ><span class="input__label">{$_("profile.form.club")}</span>
  <div style="display: block;">
    <input
      on:input={(event) =>
        (clubSuggestions = clubs.filter(
          (item) =>
            item.name
              .toLowerCase()
              .includes(event.target.value.toLowerCase()) &&
            item.name !== event.target.value
        ))}
      class="input__text"
      role="combobox"
      aria-autocomplete="list"
      aria-expanded="false"
      autocomplete="off"
      bind:value={user.club}
      id="Klubb"
    />
    {#if user.club.length > 0 && clubSuggestions.length > 0}
      <div class="input__suggestions">
        {#each clubSuggestions as club}
          <div
            id={club.abbr}
            class="input__suggestion {club.abbr === selectedClub
              ? 'input__suggestion--selected'
              : ''}"
            on:mouseover={() => (selectedClub = club.abbr)}
            on:click={() => {
              user.club = club.name;
              clubSuggestions = [];
            }}
          >
            {club.name}, {club.abbr}
          </div>
        {/each}
      </div>
    {/if}
  </div></label
>
